const PAIR_SEPARATOR = ' / ';

function shortenPerson(name: string): string {
  const parts = name.trim().split(/\s+/);

  if (parts.length < 2) {
    return name.trim();
  }

  const [firstName, ...rest] = parts;

  return `${firstName.charAt(0)}. ${rest.join(' ')}`;
}

// Na telefonie pełne imiona rozpychały kartę meczu na cztery linie — w parze
// deblowej mieszczą się cztery nazwiska, a liczy się tylko rozpoznanie zawodnika.
export function shortenSideName(name: string): string {
  return name.split('/').map(shortenPerson).join(PAIR_SEPARATOR);
}
